import { lazyWithReload } from 'utils/lazyWithReload';

export const WebCallDeletedSection = lazyWithReload(
  () => import('./WebCallDeletedSection')
);
export const WebCallExpiredSection = lazyWithReload(
  () => import('./WebCallExpiredSection')
);
